var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9F9F9"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M256,512c110.07,0,203.906-69.472,240.076-166.957H15.922C52.094,442.528,145.928,512,256,512z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "356.174,211.478 356.174,178.087 367.304,178.087 367.304,155.826 345.043,155.826  345.043,166.957 322.783,166.957 322.783,155.826 300.522,155.826 300.522,178.087 311.652,178.087 311.652,211.478  289.391,211.478 289.391,133.567 300.522,133.567 300.522,111.307 278.261,111.307 278.261,122.435 267.13,122.435 267.13,111.307  244.87,111.307 244.87,122.435 233.739,122.435 233.739,111.307 211.478,111.307 211.478,133.567 222.609,133.567 222.609,211.478  200.348,211.478 200.348,178.087 211.478,178.087 211.478,155.826 189.217,155.826 189.217,166.957 166.957,166.957  166.957,155.826 144.696,155.826 144.696,178.087 155.826,178.087 155.826,211.478 133.565,211.478 133.565,300.522  378.435,300.522 378.435,211.478  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M256,289.391c-18.441,0-33.391,14.95-33.391,33.391c0,14.536,9.294,26.9,22.261,31.484v46.43h-33.391 v44.522h55.652v-90.951c12.967-4.584,22.261-16.947,22.261-31.484C289.391,304.342,274.441,289.391,256,289.391z M256,333.913 c-6.147,0-11.13-4.984-11.13-11.13c0-6.147,4.983-11.13,11.13-11.13s11.13,4.983,11.13,11.13 C267.13,328.929,262.147,333.913,256,333.913z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGi);
export default __webpack_public_path__ + "static/media/gi.56deca68c38788d38f63049b1adf5f98.svg";
export { ForwardRef as ReactComponent };